module.exports = __webpack_public_path__ + "static/media/Sampdoria.c5f97b26.png";